import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SidebarComponent } from './sidebar.component';
import { AuthDirective } from '../auth.directive';

@NgModule({
    imports: [ RouterModule, CommonModule ],
    declarations: [ SidebarComponent, AuthDirective ],
    exports: [ SidebarComponent,AuthDirective ]
})
export class SidebarModule {}
